import { CSSProperties } from 'react'
import { RenderElementProps } from 'slate-react'

import styles from './Figure.module.scss'

interface IProps {
  style: CSSProperties
}

export const Figure = (props: RenderElementProps & IProps) => {
  return (
    <figure className={styles.root} style={props.style} {...props.attributes}>
      <div className={styles.content}>{props.children}</div>
    </figure>
  )
}
